import { z } from 'zod';
export const FormattingConfigSchema = z.object({
    bold: z.boolean(),
    italic: z.boolean(),
    underline: z.boolean(),
    bulletList: z.boolean(),
    orderedList: z.boolean(),
    table: z.boolean(),
});
export const STEP_FORMATTING_RULES = {
    info: { bold: true, italic: true, underline: true, bulletList: true, orderedList: true, table: true },
    text: { bold: true, italic: true, underline: true, bulletList: false, orderedList: false, table: false },
    mcq: { bold: true, italic: true, underline: false, bulletList: false, orderedList: false, table: false },
    true_false: { bold: true, italic: true, underline: false, bulletList: false, orderedList: false, table: false },
    cloze: { bold: true, italic: true, underline: false, bulletList: false, orderedList: false, table: true },
    cloze_diagram: { bold: true, italic: true, underline: false, bulletList: false, orderedList: false, table: false },
    cloze_image: { bold: true, italic: false, underline: false, bulletList: false, orderedList: false, table: false },
    ranking: { bold: true, italic: true, underline: false, bulletList: false, orderedList: false, table: false },
    classify: { bold: true, italic: true, underline: false, bulletList: false, orderedList: false, table: false },
    image_hotspot: { bold: true, italic: true, underline: false, bulletList: false, orderedList: false, table: false },
    numeric: { bold: true, italic: true, underline: true, bulletList: false, orderedList: false, table: false },
};
//# sourceMappingURL=formatting.js.map